export const activities = [
  "coffee", "walks", "hiking", "cooking", "reading", "photography", "traveling", 
  "concerts", "dancing", "swimming", "cycling", "gaming", "painting", "writing",
  "meditating", "yoga", "volunteering", "learning languages", "watching movies", 
  "listening to music", "gardening", "baking", "board games", "exploring cafes",
  "stargazing", "picnics", "museums", "art galleries", "coding", "fishing",
  "surfing", "rock climbing", "bird watching", "knitting", "playing instruments",
  "wine tasting", "crafting", "journaling", "running", "camping", "backpacking",
  "pottery", "calligraphy", "astronomy", "geocaching", "urban exploration", 
  "blogging", "podcasting", "mixology", "home brewing", "chess"
];

export const getRandomActivity = () => {
  return activities[Math.floor(Math.random() * activities.length)];
};

export const getTwoRandomActivities = () => {
  const shuffled = [...activities].sort(() => 0.5 - Math.random());
  return [shuffled[0], shuffled[1]];
};
